module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00299.43d40b08.jpg";